import { render } from "./private.vue?vue&type=template&id=5db386c9&scoped=true"
import script from "./private.vue?vue&type=script&lang=js"
export * from "./private.vue?vue&type=script&lang=js"

import "./private.vue?vue&type=style&index=0&id=5db386c9&lang=css"
import "./private.vue?vue&type=style&index=1&id=5db386c9&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db386c9"]])

export default __exports__